module.exports = __webpack_public_path__ + "static/media/confirm-inquiry-selected.4cab3650.svg";